export default "__VITE_ASSET__9db39693__"